var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 37.042 37.042",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_214_",
    transform: "matrix(.085864 0 0 .074083 -3.4603 -.4445)",
    strokeWidth: 3.3174
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    d: "m187.7 329h-11.4v51.3h11.4c5.6 0 10.1-1.9 13.4-5.7s5-8.7 5-14.6v-10.7c0-5.9-1.7-10.7-5-14.5-3.3-3.9-7.8-5.8-13.4-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    d: "m365.6 285.9h-325.3v133.9h276.3zm-221.7 71.3c-4.4 4-10.4 5.9-18.1 5.9h-15.1v26.5h-11.7v-70h26.8c7.7 0 13.8 2 18.1 6 4.4 4 6.6 9.2 6.6 15.7 0 6.7-2.2 11.9-6.6 15.9zm73.8 2.8c0 8.8-2.8 15.9-8.3 21.4-5.6 5.5-12.8 8.3-21.7 8.3h-23.1v-70h23.1c8.9 0 16.1 2.8 21.7 8.3s8.3 12.7 8.3 21.4zm60.6-31h-33.1v21.4h28.2v9.4h-28.2v29.9h-11.7v-70h44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    d: "m125.8 329h-15.1v24.7h15.1c4.3 0 7.6-1.2 9.8-3.5s3.3-5.2 3.3-8.8-1.1-6.5-3.3-8.9c-2.2-2.3-5.5-3.5-9.8-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "m352.9 6h-245.5c-7.3 0-13.3 6-13.3 13.3v256.8h26.6v-243.5h232.2v92.2h92.2v354.6h-324.4v-49.8h-26.6v63.1c0 7.3 6 13.3 13.3 13.3h351c7.3 0 13.3-6 13.3-13.3v-367.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_17_",
    x: 156.2,
    y: 171.4,
    width: 253.4,
    height: 19.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_16_",
    x: 156.2,
    y: 209.5,
    width: 213.3,
    height: 19.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.b08be7c445c95a0ba557cfce2545b7ac.svg";
export { ForwardRef as ReactComponent };